/*
 * @Description: 全局常量定义文件
 * @Author: laoliu、wanqian
 * @Date: 2022-03-16 17:04:11
 */

// 当前运行环境: dev/test/pro，用于调用系统升级公告接口
let ENV_MODE = '';
// 当前应用程序名，用于调用系统升级公告接口
const APP_NAME = 'hgcloud-mng';
//腾讯地图SDK
let QQMAPWX_KEY = '';

switch (process.env.NODE_ENV) {
    case 'test':
        ENV_MODE = 'test';
        QQMAPWX_KEY = "Q72BZ-ZFZWB-Q2KU6-NGEZQ-657T5-XRBTC";
        break;
    case 'production':
        ENV_MODE = 'pro';
        QQMAPWX_KEY = "Q72BZ-ZFZWB-Q2KU6-NGEZQ-657T5-XRBTC";
        break;
    case 'sdjktest':
        ENV_MODE = 'sdjktest';
        QQMAPWX_KEY = "MUZBZ-YGQWQ-2ET55-2FQMU-OOFLE-RGBES";
        break;
    case 'sdjk':
        ENV_MODE = 'sdjk';
        QQMAPWX_KEY = "MUZBZ-YGQWQ-2ET55-2FQMU-OOFLE-RGBES";
        break;
    default:
        ENV_MODE = 'dev';
        QQMAPWX_KEY = "Q72BZ-ZFZWB-Q2KU6-NGEZQ-657T5-XRBTC";
        break;
}

export { ENV_MODE, APP_NAME };

// IMS公告获取地址
let URL_RETRIEVE_PUBLIC_NOTICE = '';
if (process.env.NODE_ENV == 'sdjk') {
    URL_RETRIEVE_PUBLIC_NOTICE = `https://www.szjkhealth.com.cn:3443/ims-bizme/api/extbizme/pubntc/v20/publicnotice/intime/${APP_NAME}/pro`
} else {
    URL_RETRIEVE_PUBLIC_NOTICE = `https://jtyhaly.medvision.com.cn/ims-bizme/api/extbizme/pubntc/v20/publicnotice/intime/${APP_NAME}/${ENV_MODE}`
}

export {URL_RETRIEVE_PUBLIC_NOTICE};

export const BASE_URL = "./api";
const Constant = {
    //SessionStorage存储key
    SESSION_ADMIN_TYPE: "adminType",
    SESSION_IDENTIFIER: "curInstIdentifier",

    /** 机构自行注册标识 */
    FLAG_INST_SELF_REG: '_register',

    //系统中各定时器的间隔时间
    INTERVAL_MESSAGE: 1000 * 60 * 5, //5分钟

    //图片限制大小
    LIMIT_IMG_SIZE_1: 1024, //1M
    LIMIT_IMG_SIZE_2: 2048, //2M
    LIMIT_IMG_SIZE_5: 5120, //5M

    //腾讯地图SDK
    QQMAPWX_KEY: QQMAPWX_KEY,

    //SM4密钥
	ENCRYPTION_KEY_NAME: 'hgcMngSm4',
	ENCRYPTION_KEY: '95bb5104ef6853fa298052c65e518e99',
	
	SIGNATURE_KEY_NAME: 'hgcMngRsa',
	SIGNATURE_KEY: `-----BEGIN RSA PRIVATE KEY-----
	MIIBOwIBAAJBAMLvFYXFftZQ78JnU+KZ1gDcZBSDO9piKKka0ypcBmUpZzN/MkIj
	+JOwrSHM0htiNXXWqApYcNs29CsLS8sTpSsCAwEAAQJAcUlPAcIoF1dML3erWYq7
	wx5SD1XBSAY5ySUsyXZXxRvJUuyRXIiVgsr2frBAq6zliKKVAnRBg6A0dtmIbFMU
	CQIhAPEx6lBrpsaeCZmDuHGT//CG4lQzCB8ppX/JKh7bW3sFAiEAzuY7koK03Kez
	ZSast2W7gjPeYmSMw+6nlndqRyTxdm8CIARyHxeMZG6UyyiBPQ0a5UTRt6pFpois
	g9hvJM+cy3rhAiEAv45wF1zGoQjvUjZ1cLNS4OCvA7/+iCU8qlXTYx00JicCIQDm
	YjaXCxsX1e8HqGt2wnGKoYl5XeDqcpNXz6ls2CLADQ==
	-----END RSA PRIVATE KEY-----`,

    // 协议接口
    URL_XHY_USAGE_AGREEMENT: "https://hugongyun.com/hgcloud-mng/docs/XHYUsageAgreement.html",
    URL_XHY_ADMISSION_NOTICE: "https://hugongyun.com/hgcloud-mng/docs/XHYAdmissionNotice.html",
    URL_PROVINCE_CITY_XLSX: "https://hugongyun.com/hgcloud-mng/docs/省市区编码对照表.xlsx",
    URL_SDJK_XHY_USAGE_AGREEMENT: "https://hg.szjkhealth.com.cn:4443/hgcloud-mng/docs/XHYUsageAgreement.html",
    URL_SDJK_XHY_ADMISSION_NOTICE: "https://hg.szjkhealth.com.cn:4443/hgcloud-mng/docs/XHYAdmissionNotice.html",

    //1-A 页面框架接口URL
    URL_LOGIN: BASE_URL + "/common/admin/login",
    URL_LOGOUT: BASE_URL + "/common/admin/logout",

    URL_GET_INSTITUTION_BY_IDENTIFIER: BASE_URL + "/common/medicalinst/{type}/identifier/{identifier}",
    URL_GET_CURRENT_ADMIN_INSTITUTION: BASE_URL + "/common/admin/medicalinst/{type}/current/{withMedicalInstList}",
    URL_LIST_CURRENT_ADMIN_INSTITUTIONS: BASE_URL + "/common/admin/current/institutionlist",
    URL_UPDATE_PASSWORD: BASE_URL + "/common/admin/current/password",
    URL_UPDATE_ICON: BASE_URL + "/common/admin/current/icon",

    URL_UPDATE_NOTICE_STATUS: BASE_URL + "/common/v10/notice/{id}/read",
    URL_UPDATE_NOTICE_LIST: BASE_URL + "/common/v10/notice/list",

    URL_GET_ADVERT_PICTURE: BASE_URL + "/common/v31/advertpicture/list/{type}/{identifier}",

    //1-B 机构注册接口
    URL_SAVE_REGISTER_INSTITUTION: BASE_URL + "/common/instreg/v11/reginstitution",
    URL_UPDATE_REGISTER_INSTITUTION: BASE_URL + "/common/instreg/v11/reginstitution",
    URL_GET_REGISTER_INSTITUTION_DETAILS: BASE_URL + "/common/instreg/v32/reginstitution/details",
    URL_GET_REGISTER_INSTITUTION_DO_4_ADD: BASE_URL + "/common/instreg/v11/reginstitutiondo",
    URL_GET_REGISTER_INSTITUTION_DO_4_UPDATE: BASE_URL + "/common/instreg/v32/reginstitutiondo",
    URL_GET_REGISTER_INSTITUTION_REVIEW_RESULT: BASE_URL + "/common/instreg/v11/review/reginstitution",
    URL_IS_UNIQUE_USERNAME: BASE_URL + "/common/instreg/v32/reginstitution/username/excludeId",

    //1-C 消息中心接口
    URL_GET_NOTICE_FILTER_DO: BASE_URL + "/noticemng/noticelist/v22/unanth/noticefilterdo",
    URL_GET_PAGE_NOTICES_V22: BASE_URL + "/noticemng/noticelist/v22/unanth/notice/page/filter",
    URL_LIST_FILTER_NOTICES: BASE_URL + "/noticemng/noticelist/v22/unanth/notice/list/filter",
    URL_UPDATA_ALL_NOTICE_23_READ: BASE_URL + "/noticemng/noticelist/v23/unanth/notice/read",

    //2-A 运营总览接口URL
    URL_GET_OVERVIEW_CUMULATIVE_DO: BASE_URL + "/overview/overview/v20/overviewcumulativedo",
    URL_GET_OVERVIEW_DO: BASE_URL + "/overview/overview/v20/overviewdo/filter",
    URL_GET_OVERVIEW_ORDER_STATISTICS_DO: BASE_URL + "/overview/overview/v20/overvieworderstatisticsdo",
    URL_GET_OVERVIEW_PAID_ORDER_TREND: BASE_URL + "/overview/overview/v20/overviewpaidordertrenddo",
    URL_GET_OVERVIEW_TOP_STATISTICS_DO: BASE_URL + "/overview/overview/v20/overviewtopstatisticsdo",
    URL_GET_USER_OR_ATTENDANT_INFO_STATISTICS_DO: BASE_URL + "/overview/overview/v20/userorattendantinfostatisticsdo",
    URL_GET_USER_OR_ATTENDANT_REGIST_STATISTICS_DO: BASE_URL + "/overview/overview/v20/userorattendantregiststatisticsdo",

    //3-A 机构接口URL
    URL_SAVE_INSTITUTION: BASE_URL + "/instmng/instlist/v10/institution",
    URL_UPDATE_INSTITUTION: BASE_URL + "/instmng/instlist/v10/institution",
    URL_INST_IS_UNIQUE_IDENTIFIER: BASE_URL +
        "/instmng/instlist/v10/institution/identifier/{identifier}/excludeId/{Id}",
    URL_IS_UNIQUE_NAME: BASE_URL + "/instmng/instlist/v10/institution/name/{name}/excludeId/{Id}",
    URL_PAGE_INSTITUTIONS: BASE_URL + "/instmng/instlist/v10/institution/page/filter",
    URL_LIST_SIMPLE_INSTITUTIONS: BASE_URL + "/instmng/instlist/v10/institution/simple/list",
    URL_GET_INSTITUTION: BASE_URL + "/instmng/instlist/v32/institution/details",
    URL_UPDATE_INSTITUTION_STATUS: BASE_URL + "/instmng/instlist/v32/institution/status",
    URL_GET_INSTITUTIONDO_4_ADD: BASE_URL + "/instmng/instlist/v10/institutiondo",
    URL_GET_INSTITUTIONDO_4_UPDATE: BASE_URL + "/instmng/instlist/v32/institutiondo",
    URL_GET_INSTITUTION_FILTERDO: BASE_URL + "/instmng/instlist/v10/institutionfilterdo",
    URL_DOWNLOAD_CONTRACT: BASE_URL + "/instmng/instlist/v32/institution/contract/download",

    //03A-1-收入设置API
    URL_GET_INCOME_CFG_DO: BASE_URL + '/instmng/instlist/v32/incomecfgdo',
    URL_SAVE_OR_UPDATE_INCOME_CFG: BASE_URL + '/instmng/instlist/v32/incomecfg',

    //3-B 人员接口URL
    URL_SAVE_ATTENDANT: BASE_URL + "/instmng/atdnlist/v10/attendant",
    URL_UPDATE_ATTENDANT: BASE_URL + "/instmng/atdnlist/v10/attendant",
    URL_LIST_ATTENDANTS: BASE_URL + "/instmng/atdnlist/v10/attendant/list/filter",
    URL_PAGE_ATTENDANTS: BASE_URL + "/instmng/atdnlist/v10/attendant/page/filter",
    URL_LIST_SIMPLE_ATTENDANTS: BASE_URL + "/instmng/atdnlist/v10/attendant/simple/list",
    URL_DELETE_ATTENDANT: BASE_URL + "/instmng/atdnlist/v10/attendant/{id}",
    URL_UPDATE_ATTENDANT_STATUS: BASE_URL + "/instmng/atdnlist/v32/attendant/status",
    URL_GET_ATTENDANT_DO_4_ADD: BASE_URL + "/instmng/atdnlist/v10/attendantdo",
    URL_GET_ATTENDANT_DO_4_UPDATE: BASE_URL + "/instmng/atdnlist/v32/attendantdo",
    URL_GET_ATTENDANT_FILTER_DO: BASE_URL + "/instmng/atdnlist/v10/attendantfilterdo",
    URL_VAILDATE_IDNO: BASE_URL + "/instmng/atdnlist/v32/attendant/institution/idno",
    URL_UPDATE_ATTENDANT_DISPATCH_STATUS: BASE_URL + "/instmng/atdnlist/v10/attendantdispatchstatus",

    URL_GET_ATTENDANT_AND_CERT_DETAILS: BASE_URL + "/instmng/atdnlist/v32/attendant/details",

    URL_GET_ATTENDANT_DO_DISPATCH_PVG: BASE_URL + "/instmng/atdnlist/v32/attendantdo/dispatchpvg",
    URL_SAVE_ATTENDANT_DISPATCH_PVG: BASE_URL + "/instmng/atdnlist/v31/attendant/dispatchpvg",
    URL_GET_ATTENDANT_CANCEL_DISPATCH_DO: BASE_URL + "/instmng/atdnlist/v31/attendantcanceldispatchdo",
    URL_GET_ATTENDANT_REALNAME: BASE_URL + "/instmng/atdnlist/v31/attendant/realname",
    URL_LIST_REVENUE_SHARING_DOCNURSES: BASE_URL + "/instmng/atdnlist/v32/unanth/attendant/list/filter",
    URL_EXPORT_ATTENDANTS: BASE_URL + '/instmng/atdnlist/v328/attendant/list/filter/export',
    URL_GET_ATTENDANT_DO_ACCEPT_PVG: BASE_URL + "/instmng/atdnlist/v328/attendantdo/acceptpvg",
    URL_SAVE_OR_UPDATE_ATTENDANT_ACCEPT_PVG: BASE_URL + "/instmng/atdnlist/v328/attendant/acceptpvg",



    //3-C 班次规则接口URL
    URL_SAVE_DUTY_RULE: BASE_URL + "/instmng/dutyrule/v10/dutyrule",
    URL_UPDATE_DUTY_RULE: BASE_URL + "/instmng/dutyrule/v10/dutyrule",
    URL_PAGE_DUTY_RULES: BASE_URL + "/instmng/dutyrule/v10/dutyrule/page/filter",
    URL_GET_DUTY_RULE_4_ADD: BASE_URL + "/instmng/dutyrule/v10/dutyruledo",
    URL_GET_DUTY_RULE_4_UPDATE: BASE_URL + "/instmng/dutyrule/v32/dutyruledo",
    URL_GET_DUTY_RULE_FILTER_DO: BASE_URL + "/instmng/dutyrule/v10/dutyrulefilterdo",
    URL_DELETE_DUTY_RULE: BASE_URL + "/instmng/dutyrule/v32/dutyrule",

    //3-D 评价列表API
    URL_PAGE_COMMENTS: BASE_URL + "/instmng/commentlist/v21/comment/page/filter",
    URL_GET_COMMENT_FILTER_DO: BASE_URL + "/instmng/commentlist/v21/commentfilterdo",
    URL_UPDATE_COMMENT_VISIBLE: BASE_URL + "/instmng/commentlist/v32/comment/visible",

    //3-E 商户管理API
    URL_PAGE_MERCHANTS: BASE_URL + "/instmng/mchlist/v23/merchant/page/filter",
    URL_GET_MERCHANT_FILTER_DO: BASE_URL + "/instmng/mchlist/v23/merchantfilterdo",
    URL_GET_MERCHANT_DO_4_ADD: BASE_URL + "/instmng/mchlist/v23/merchantdo",
    URL_GET_MERCHANT: BASE_URL + "/instmng/mchlist/v23/merchant/{id}",
    URL_SAVE_MERCHANT: BASE_URL + "/instmng/mchlist/v23/merchant",
    URL_UPDATE_MERCHANT_STATUS: BASE_URL + "/instmng/mchlist/v23/merchant/{id}/status/{status}",
    URL_GET_MERCHANT_PRIVIAGE: BASE_URL + "/instmng/mchlist/v23/merchantprivilege",
    URL_GET_LIST_PROVINCES: BASE_URL + "/instmng/mchlist/v30/merchant/povince/list",
    URL_GET_LIST_CITIES: BASE_URL + "/instmng/mchlist/v30/merchant/city/{provinceCode}/list",
    URL_GET_LIST_BRANCHES: BASE_URL + "/instmng/mchlist/v30/merchant/branch/list",
    URL_GET_COMMON_CFG_REGION: BASE_URL + "/instmng/mchlist/v30/merchant/commoncfgregion/{id}",

    //3-F 机构分成配置API
    URL_LIST_INST_REVENUE_SHARING_CFGS: BASE_URL + "/instmng/mchlist/v32/revenuesharingcfg/list/institution",
    URL_SAVE_OR_UPDATE_INST_REVENUE_SHARING_CFG_LIST_V32: BASE_URL + "/instmng/mchlist/v32/revenuesharingcfg/list/institution",

    //3-G证书API
    URL_SYNC_OCC_CERTIFICATES: BASE_URL + "/instmng/atdnlist/v32/certificate/occ/sync",
    URL_PAGE_CERT_SYNC_HISTORY: BASE_URL + "/instmng/atdnlist/v32/certsynchistory/lately",

    // 03H-钱账通商户API
    URL_PAGE_LKL_MERCHANTS: BASE_URL + '/instmng/lklmchlist/v32/lklmerchant/page/filter',
    URL_GET_LKL_MERCHANT_FILTER_DO: BASE_URL + '/instmng/lklmchlist/v32/lklmerchantfilterdo',
    URL_LIST_SIMPLE_INSTS_OF_NO_OPEN_MEMBER: BASE_URL + '/instmng/lklmchlist/v32/institution/simple/noopenmember/list',
    URL_UPDATE_LKL_MERCHANT_STATUS: BASE_URL + '/instmng/lklmchlist/v32/lklmerchant/{id}/status/{status}',
    URL_GET_URL_4OPEN_MERCHANT: BASE_URL + '/instmng/lklmchlist/v32/url/lkl/openmember',
    URL_LIST_LKL_MERCHANT_ATTENDANTS: BASE_URL + '/finance/settlementacct/v32/attendant/list',

    //4-A医院接口URL
    URL_GET_HOSPITAL_PRIVILEGE: BASE_URL + "/hspmng/hsplist/v10/hospitalprivilege",
    URL_GET_HOSPITAL_LIST_FILTERDO: BASE_URL + "/hspmng/hsplist/v10/hospitalfilterdo",
    URL_GET_HOSPITALDO_ADD: BASE_URL + "/hspmng/hsplist/v10/hospitaldo",
    URL_GET_HOSPITALDO_UPDATE: BASE_URL + "/hspmng/hsplist/v32/hospitaldo",
    URL_UPDATE_HOSPITAL_STATUS: BASE_URL + "/hspmng/hsplist/v32/hospital/status",
    URL_GET_HOSPITAL_WITH_DETAILS: BASE_URL + "/hspmng/hsplist/v32/hospital/details",
    URL_GET_ADMIN_HOSPITAL_SIMPLE_LIST: BASE_URL + "/hspmng/hsplist/v32/hospital/simple/list",
    URL_GET_ADMIN_HOSPITAL_LIST: BASE_URL + "/hspmng/hsplist/v10/hospital/page/filter",
    URL_SAVE_HOSPITAL_WITH_DETAILS: BASE_URL + "/hspmng/hsplist/v10/hospital",
    URL_UPDATE_HOSPITAL_WITH_DETAILS: BASE_URL + "/hspmng/hsplist/v10/hospital",
    URL_DELETE_HOSPITAL: BASE_URL + "/hspmng/hsplist/v10/hospital/{id}",

    URL_GET_HOSPITAL_DO4BINDING_INST: BASE_URL + "/hspmng/hsplist/v32/hospitalinstitutiondo/bindinginst",
    URL_BINDING_INSTITUTION: BASE_URL + "/hspmng/hsplist/v32/hospital/bindinginst",
    URL_UNBINDING_INSTITUTION_LIST: BASE_URL + "/hspmng/hsplist/v22/hospital/unbindinginst/list",
    URL_GET_HOSPITAL_DO4UNBINDING_INST: BASE_URL + "/hspmng/hsplist/v32/hospitalinstitutiondo/unbindinginst",
    URL_HAS_BINDING_INSTITUTION: BASE_URL + "/hspmng/hsplist/v32/hospital/hasbindinginst",

    URL_GET_HOSPITAL_COMMENUSERFILTERDO4_INSTITUTION: BASE_URL + "/hspmng/hsplist/v23/hospitaldo/commonuse/filter",

    URL_GET_HOSPITAL_DO4BINDING_HSERVICE: BASE_URL + "/hspmng/hsplist/v32/hospitaldo/bindinghservice",
    URL_SAVE_OR_UPDATE_HOSPITAL_HSERVICE: BASE_URL + "/hspmng/hsplist/v31/hospital/bindinghservice",

    //4-B 科室接口URL
    URL_SAVE_DEPARTMENT_WITH_INPATIENT: BASE_URL + "/hspmng/deptlist/v10/department",
    URL_UPDATE_DEPARTMENT_WITH_INPATIENT: BASE_URL + "/hspmng/deptlist/v10/department",
    URL_GET_DEPARTMENT_LIST_FILTERDO: BASE_URL + "/hspmng/deptlist/v10/departmentfilterdo",
    URL_GET_DEPARTMENT_LIST: BASE_URL + "/hspmng/deptlist/v10/department/page/filter",
    URL_DELETE_DEPARTMENT: BASE_URL + "/hspmng/deptlist/v32/department",
    URL_UPDATE_DEPARTMENT_STATUS: BASE_URL + "/hspmng/deptlist/v32/department/status",
    URL_GET_DEPARTMENT_LEVEL2_DO_ADD: BASE_URL + "/hspmng/deptlist/v10/departmentdo/level2",
    URL_GET_DEPARTMENT_LEVEL2_DO_UPDATE: BASE_URL + "/hspmng/deptlist/v10/departmentdo/level2/{id}",
    URL_GET_DEPARTMENT_TREE_DO: BASE_URL + "/hspmng/deptlist/v32/departmentdo/tree",
    URL_UPDATE_DEPARTMENT_INPATIENT: BASE_URL + "/hspmng/deptlist/v10/inpatient",
    URL_DELETE_INPATIENT: BASE_URL + "/hspmng/deptlist/v32/inpatient",
    URL_GET_DEPARTMENT_INPATIENT_DO: BASE_URL + "/hspmng/deptlist/v32/inpatientdo",
    URL_GET_DEPARTMENT_TREE_HOSPITAL_DO: BASE_URL + "/hspmng/hsplist/v32/hospital/admin/simple/list",

    URL_UPDATE_LEVEL_2DEPARTMENT: BASE_URL + "/hspmng/deptlist/v22/department/level2",
    URL_SAVE_LEVEL_2DEPARTMENT: BASE_URL + "/hspmng/deptlist/v22/department/level2",
    URL_GET_LEVEL_2DEPARTMENT_DO4UPDATE: BASE_URL + "/hspmng/deptlist/v32/departmentdo/level2/update",
    URL_GET_LEVEL_2DEPARTMENT_DO4ADD_V22: BASE_URL + "/hspmng/deptlist/v32/departmentdo/level2/add",
    URL_UPDATE_LEVEL_1DEPARTMENT: BASE_URL + "/hspmng/deptlist/v22/department/level1",
    URL_SAVE_LEVEL_1DEPARTMENT: BASE_URL + "/hspmng/deptlist/v22/department/level1",
    URL_LEVEL_1DEPARTMENT_NAME_IS_REPEAT: BASE_URL + "/hspmng/deptlist/v22/department/name/level1/isunique",
    URL_GET_LEVEL_1DEPARTMENT_DO4SELECT_HOSPITAL: BASE_URL + "/hspmng/deptlist/v32/departmentdo/level1/list",
    URL_GET_LEVEL_1DEPARTMENT_DO4UPDATE: BASE_URL + "/hspmng/deptlist/v32/departmentdo/level1",
    URL_GET_LEVEL_1DEPARTMENT_DO4ADD: BASE_URL + "/hspmng/deptlist/v22/departmentdo/level1",

    //5-A 服务项目访问接口
    URL_GET_HSERVICE_FILTER_DO: BASE_URL + "/hsvcmng/hsvclist/v10/hservicefilterdo",
    URL_GET_PAGE_HSERVICES: BASE_URL + "/hsvcmng/hsvclist/v10/hservice/page/filter",
    URL_UPDATE_HSERVICE_STATUS: BASE_URL + "/hsvcmng/hsvclist/v32/hservice/status",
    URL_DELETE_HSERVICE_LIST: BASE_URL + "/hsvcmng/hsvclist/v32/hservice",
    URL_GET_HSERVICE_DO_4_ADD: BASE_URL + "/hsvcmng/hsvclist/v10/hservicedo",
    URL_GET_HSERVICE_DO_4_UPDATE: BASE_URL + "/hsvcmng/hsvclist/v32/hservicedo",
    URL_GET_HSERVICE_DETAILS_DO: BASE_URL + "/hsvcmng/hsvclist/v32/hservicedetaildo/details",
    URL_OPENING_HSERVICE: BASE_URL + "/instmng/instlist/v32/openinghservice",
    URL_GET_LIST_OPENING_HSERVICE: BASE_URL + "/instmng/instlist/v32/openinghservice/list",
    URL_SAVE_HSERVICE: BASE_URL + "/hsvcmng/hsvclist/v10/hservice",
    URL_UPDATE_HSERVICE: BASE_URL + "/hsvcmng/hsvclist/v10/hservice",

    //服务项目导入访问接口
    URL_GET_IMPORT_HSERVICE_CFG_FILTER_DO: BASE_URL + "/hsvccfg/hsvccfg/v11/unanth/import/hservicecfgfilterdo",
    URL_GET_IMPORT_HSERVICE_CFG_LIST: BASE_URL + "/hsvccfg/hsvccfg/v30/unanth/hservicecfg/list",
    URL_SAVE_IMPORT_HSERVICES_FORM_CFG: BASE_URL + "/hsvcmng/hsvclist/v11/hservice/sysimport",

    //绑定医院访问接口
    URL_GET_HSERVICE_DO4BINDING_HOSPITAL: BASE_URL + "/hsvcmng/hsvclist/v32/hservicedo/bindinghospital",
    URL_SAVE_OR_UPDATE_HSERVICE_HOSPITAL: BASE_URL + "/hsvcmng/hsvclist/v31/hservice/bindinghospital",

    //5-B 服务事项访问接口
    URL_PAGE_MATTERS: BASE_URL + "/hsvcmng/hsvcmatter/v22/matter/page/filter",
    URL_GET_TREE_MATTER: BASE_URL + "/hsvcmng/hsvcmatter/v10/matter/tree/filter",
    URL_GET_MATTER_FILTER_DO: BASE_URL + "/hsvcmng/hsvcmatter/v10/matterfilterdo",
    URL_SAVE_MATTER: BASE_URL + "/hsvcmng/hsvcmatter/v10/matter",
    URL_UPDATE_MATTER: BASE_URL + "/hsvcmng/hsvcmatter/v10/matter",
    URL_GET_MATTER: BASE_URL + "/hsvcmng/hsvcmatter/v32/matter",
    URL_DELETE_MATTER: BASE_URL + "/hsvcmng/hsvcmatter/v32/matter",

    //服务事项导入访问接口
    URL_IPMORT_MATTER_TREE: BASE_URL + "/hsvccfg/mattercfg/v11/unanth/mattergroup/import/tree/filter",
    URL_SAVE_IMPORT_MATTERS_FORM_CFG: BASE_URL + "/hsvcmng/hsvcmatter/v11/matter/sysimport",

    //5-C 服务分成配置API
    URL_LIST_HSVC_REVENUE_SHARING_CFGS: BASE_URL + "/hsvcmng/hsvclist/v32/revenuesharingcfg/list/hservice",
    URL_SAVE_OR_UPDATE_HSVC_REVENUE_SHARING_CFG_LIST: BASE_URL + "/hsvcmng/hsvclist/v23/revenuesharingcfg/list/hservice",
    URL_GET_HSVC_REVENUE_SARING_CFG_PRIVILEGE: BASE_URL + "/hsvcmng/hsvclist/v32/revenuesharingcfgprivilege",
    URL_DELETE_HSVC_REVENUE_SHARING_CFG_LIST: BASE_URL + "/hsvcmng/hsvclist/v32/revenuesharingcfg/list/hservice",

    //6-A 订单管理
    URL_GET_ORDER_LIST_FILTER_DO: BASE_URL + "/ordermng/orderlist/v11/orderfilterdo",
    URL_GET_ORDER_STATUS_COUNT: BASE_URL + "/ordermng/orderlist/v11/orderstatus/count",
    URL_PAGE_ORDER_LIST: BASE_URL + "/ordermng/orderlist/v11/order/page/filter",
    URL_GET_ORDER_DETAILS: BASE_URL + "/ordermng/orderlist/v32/orderdo/details",
    URL_GET_ORDER_PAYMENT_DETAILS: BASE_URL + "/ordermng/orderlist/v32/orderdo/payment",
    URL_GET_ORDER_DETAILS_OF_NO: BASE_URL + "/ordermng/orderlist/v21/orderdo/no/details",
    URL_GET_NEW_ORDER_STATUS_COUNT: BASE_URL + "/ordermng/orderlist/v31/orderstatus/count",
    URL_GET_LIST_ORDER_PROGRESSES: BASE_URL + '/ordermng/orderlist/v328/orderprogress/list',

    //7-A 居民用户访问接口
    URL_GET_LIST_USERS: BASE_URL + "/usermng/resident/v11/user/page/filter",
    URL_UPDATE_USER_CANORDER_STATUS: BASE_URL + "/usermng/resident/v32/user/orderstatus",
    URL_UPDATE_USER_STATUS: BASE_URL + "/usermng/resident/v32/user/status",
    URL_GET_USER_FILTER_DO: BASE_URL + "/usermng/resident/v11/userfilterdo",

    //7-B 管理员访问接口
    URL_SAVE_ADMIN: BASE_URL + "/usermng/bkuser/v10/admin",
    URL_UPDATE_ADMIN: BASE_URL + "/usermng/bkuser/v10/admin",
    URL_LIST_ADMINS: BASE_URL + "/usermng/bkuser/v10/admin/list",
    URL_PAGE_ADMINS: BASE_URL + "/usermng/bkuser/v10/admin/page/filter",
    URL_IS_UNIQUE_USER_NAME: BASE_URL + "/usermng/bkuser/v32/admin/username/excludeId",
    URL_UPDATE_ADMINS_STATUS: BASE_URL + "/usermng/bkuser/v32/admin/status",
    URL_DELETE_ADMIN: BASE_URL + "/usermng/bkuser/v32/admin",
    URL_RESET_PASSWORD: BASE_URL + "/usermng/bkuser/v32/admin/password",
    URL_GET_ADMIN_4_ADD: BASE_URL + "/usermng/bkuser/v10/admindo",
    URL_GET_ADMIN_4_UPDATE: BASE_URL + "/usermng/bkuser/v32/admindo",
    URL_GET_ADMIN_FILTER_DO: BASE_URL + "/usermng/bkuser/v10/adminfilterdo",
    URL_LIST_MEDICAL_INSTS_BY_ADMIN_TYPE: BASE_URL + "/usermng/bkuser/v32/medicalinst/list",
    URL_GET_ADMIN_DETAILS: BASE_URL + "/usermng/bkuser/v10/admindetail/{id}",
    URL_GET_ADMIN_MEDICAL_INSTS_COUNT_MSG: BASE_URL + "/usermng/bkuser/v32/admin/countmsg",

    URL_SAVE_SUB_ADMIN: BASE_URL + "/usermng/bkuser/v31/subadmin",
    URL_UPDATE_SUB_ADMIN: BASE_URL + "/usermng/bkuser/v31/subadmin",
    URL_GET_SUB_ADMIN_DO4ADD: BASE_URL + "/usermng/bkuser/v32/subadmindo/institution",
    URL_GET_SUB_ADMIN_DO4UPDATE: BASE_URL + "/usermng/bkuser/v32/subadmindo",
    URL_UPDATE_ADMIN_WXMSG: BASE_URL + "/usermng/bkuser/v32/admin/usewxmsg",
    URL_GET_QR_CODE: BASE_URL + "/usermng/bkuser/v31/qrcode/bindingoa/{memberId}",

    //8-A 人员审核接口
    URL_GET_PAGE_ATTENTDANT_REVIEWS: BASE_URL + "/reviewmng/atdnreview/v10/review/attendant/page/filter",
    URL_GET_IS_SUPER_ADMIN: BASE_URL + "/reviewmng/atdnreview/v10/review/issuperadmin",
    URL_GET_ATTENTDANT_REVIEW_FILTER_DO: BASE_URL + "/reviewmng/atdnreview/v10/reviewfilterdo/attendant",
    URL_GET_ATTENTDANT_REVIEW_DO: BASE_URL + "/reviewmng/atdnreview/v10/reviewdo/attendant/{id}",
    URL_UPDATE_ATTENTDANT_REVIEW_STATUS: BASE_URL + "/reviewmng/atdnreview/v10/review/attendant",

    URL_GET_ATTENTDANT_BASEINFO_REVIEW_DO: BASE_URL + "/reviewmng/atdnreview/v32/reviewdo/attendant",

    //8-B 证书审核API
    URL_GET_CERTIFICATE_REVIEW_DO: BASE_URL + "/reviewmng/atdnreview/v32/reviewdo/certificate",
    URL_UPDATE_CERTIFICATE_REVIEW_STATUS: BASE_URL + "/reviewmng/atdnreview/v30/review/certificate",

    //8-C 机构审核接口
    URL_PAGE_INSTITUTION_REVIEWS: BASE_URL + "/reviewmng/instreview/v11/review/institution/page/filter",
    URL_UPDATE_INSTITUTION_REVIEW_STATUS: BASE_URL + "/reviewmng/instreview/v11/review/institution/status",
    URL_GET_INSTITUTION_REVIEW_DO: BASE_URL + "/reviewmng/instreview/v32/unanth/reviewdo/institution",
    URL_GET_INSTITUTION_REVIEW_FILTER_DO: BASE_URL + "/reviewmng/instreview/v11/reviewfilterdo/institution",

    //8-D 商户审核API
    URL_PAGE_MERCHANT_REVIEWS: BASE_URL + "/reviewmng/mchreview/v23/review/merchant/page/filter",
    URL_GET_MERCHANT_REVIEW_FILTER_DO: BASE_URL + "/reviewmng/mchreview/v23/reviewfilterdo/merchant",
    URL_GET_MERCHANT_REVIEW: BASE_URL + "/reviewmng/mchreview/v32/merchant",
    URL_LIST_MERCHANT_REVIEW_HISTORY: BASE_URL + "/reviewmng/mchreview/v32/reviewhistory/list/merchant",
    URL_UPDATE_MERCHANT_REVIEW_RESULT: BASE_URL + "/reviewmng/mchreview/v23/review/merchant/status",
    URL_GET_MERCHANT_DO4UPDATE: BASE_URL + "/reviewmng/mchreview/v32/merchantdo",
    URL_UPDATE_MERCHANT: BASE_URL + "/reviewmng/mchreview/v23/merchant",
    URL_REVOKE_MERCHANT_REVIEW: BASE_URL + "/reviewmng/mchreview/v32/review/merchant/revoke",
    URL_GET_MERCHANT_VALIDATION_DO: BASE_URL + "/reviewmng/mchreview/v32/mchvalidationdo",
    URL_GET_MERCHANT_SIGNING_DO: BASE_URL + "/reviewmng/mchreview/v32/mchsigningdo",
    URL_GET_REVIEWER_IS_SUPER_ADMIN: BASE_URL + "/reviewmng/mchreview/v23/merchant/review/issuperadmin",

    //9-A 订单统计接口
    URL_GET_ORDER_REPORT_FILTER_DO: BASE_URL + "/report/orderreport/v11/orderreportfilterdo",
    URL_PAGE_REPORT_ORDER_LIST: BASE_URL + "/report/orderreport/v11/order/page/filter",
    URL_GET_REPORT_ORDER_CHART: BASE_URL + "/report/orderreport/v11/orderreportdo/chart/filter",
    URL_EXPORT_ORDER_LIST_2EXCEL: BASE_URL + "/report/orderreport/v30/order/download",

    //9-B 收入统计接口
    URL_GET_INCOME_REPORT_FILTER_DO: BASE_URL + "/report/income/v328/incomereportfilterdo",
    URL_PAGE_INCOMES: BASE_URL + "/report/income/v328/income/page/filter",
    URL_GET_INCOME_REPORT_DO: BASE_URL + "/report/income/v328/incomereportdo/chart/filter",
    URL_EXPORT_INCOME_EXCEL: BASE_URL + "/report/income/v32/income/download",
    URL_GET_INCOME_DETAILS_FILTER_DO: BASE_URL + "/report/income/v328/incomedetailsfilterdo",
    URL_PAGE_INCOME_REPORT_DETAILS: BASE_URL + "/report/income/v328/incomereportdetails/page/filter",

    URL_GET_DUTY_REPORT_LIST_TOP_30INSTITUTIONS: BASE_URL + '/report/dutyrpt/v33/institution/list/top30/filter',
    URL_GET_DUTY_REPORT_FILYER_DO: BASE_URL + '/report/dutyrpt/v33/dutyreportfilterdo',
    URL_GET_PAGE_DUTIES: BASE_URL + '/report/dutyrpt/v33/duty/page/filter',
    URL_GET_EXPORT_DUTY_EXCEL: BASE_URL + '/report/dutyrpt/v33/duty/list/export/excel',
    URL_GET_ATDN_DUTY_DETAILS: BASE_URL + '/report/dutyrpt/v33/duty/details',

    //10-A 服务类型配置接口
    URL_GET_LIST_HSERVICE_TYPE_CFGS: BASE_URL + "/hsvccfg/typecfg/v10/hsvctypecfgdo/list",
    URL_DELETE_HSERVICE_TYPE_CFG: BASE_URL + "/hsvccfg/typecfg/v32/hsvctypecfg",
    URL_GET_HSERVICE_TYPE_CFG: BASE_URL + "/hsvccfg/typecfg/v32/hsvctypecfg",
    URL_SAVE_HSERVICE_TYPE_CFG: BASE_URL + "/hsvccfg/typecfg/v10/hsvctypecfg",
    URL_UPDATE_HSERVICE_TYPE_CFG: BASE_URL + "/hsvccfg/typecfg/v10/hsvctypecfg",

    //10-B 服务项目配置访问接口
    URL_GET_HSERVICE_CFG_FILTER_DO: BASE_URL + "/hsvccfg/hsvccfg/v11/hservicecfgfilterdo",
    URL_GET_HSERVICE_CFG_LIST: BASE_URL + "/hsvccfg/hsvccfg/v11/hservicecfg/page/filter",
    URL_GET_HSERVICE_CFG_DO_4_ADD: BASE_URL + "/hsvccfg/hsvccfg/v11/hservicecfgdo",
    URL_GET_HSERVICE_CFG_DO_4_UPDATA: BASE_URL + "/hsvccfg/hsvccfg/v32/hservicecfgdo",
    URL_GET_HSERVICE_CFG_DETAILS: BASE_URL + "/hsvccfg/hsvccfg/v32/hservicecfg",
    URL_SAVE_HSERVICE_CFG: BASE_URL + "/hsvccfg/hsvccfg/v11/hservicecfg",
    URL_UPDATE_HSERVICE_CFG: BASE_URL + "/hsvccfg/hsvccfg/v11/hservicecfg",
    URL_DELETE_HSERVICE_CFG: BASE_URL + "/hsvccfg/hsvccfg/v32/hservicecfg",

    //10-C 服务事项配置访问接口
    URL_GET_TREE_MATTER_CFGS: BASE_URL + "/hsvccfg/mattercfg/v11/mattercfg/tree",
    URL_GET_MATTER_CFG: BASE_URL + "/hsvccfg/mattercfg/v32/mattercfg",
    URL_SAVE_MATTER_CFG: BASE_URL + "/hsvccfg/mattercfg/v11/mattercfg",
    URL_UPDATW_MATTER_CFG: BASE_URL + "/hsvccfg/mattercfg/v11/mattercfg",
    URL_DELETE_MATTER_CFG: BASE_URL + "/hsvccfg/mattercfg/v32/mattercfg",

    //10-D 服务宣传语接口调用
    URL_GET_SLOGAN_CFG_DO_LIST: BASE_URL + "/hsvccfg/hsvctypecfg/v11/unanth/slogancfgdo/list",
    URL_GET_SLOGAN_CFG: BASE_URL + "/hsvccfg/hsvctypecfg/v32/unanth/slogancfg",
    URL_SAVE_SLOGAN_CFG: BASE_URL + "/hsvccfg/hsvctypecfg/v11/unanth/slogancfg",
    URL_UPDATE_SLOGAN_CFG: BASE_URL + "/hsvccfg/hsvctypecfg/v11/unanth/slogancfg",
    URL_DELETE_SLOGAN_CFG: BASE_URL + "/hsvccfg/hsvctypecfg/v32/unanth/slogancfg",

    //11-A 用户配置接口
    URL_LIST_USERSHIPCFG: BASE_URL + "/syscfg/usercfg/v11/usershipcfg/list",
    URL_GET_USERSHIPCFG: BASE_URL + "/syscfg/usercfg/v32/usershipcfg",
    URL_SAVE_USERSHIPCFG: BASE_URL + "/syscfg/usercfg/v11/usershipcfg",
    URL_UPDATE_USERSHIPCFG: BASE_URL + "/syscfg/usercfg/v11/usershipcfg",
    URL_DELETE_USERSHIPCFG: BASE_URL + "/syscfg/usercfg/v32/usershipcfg",

    // 11-C 广告位管理配置API
    URL_LIST_ADVERT: BASE_URL + "/syscfg/advertcfg/v31/advert/page/filter",
    URL_SAVE_ADVERT: BASE_URL + "/syscfg/advertcfg/v31/advert",
    URL_UPDATE_ADVERT: BASE_URL + "/syscfg/advertcfg/v31/advert",
    URL_DELETE_ADVERT: BASE_URL + "/syscfg/advertcfg/v32/advert",
    URL_GET_ADVERT_FILTER_DO: BASE_URL + "/syscfg/advertcfg/v31/advertfilterdo",
    URL_UPDATE_ADVERT_STATUS: BASE_URL + "/syscfg/advertcfg/v32/advert/status",
    URL_GET_ADVERT_DO4ADD: BASE_URL + "/syscfg/advertcfg/v32/advertdo4add",
    URL_GET_ADVERT_DO4UPDATE: BASE_URL + "/syscfg/advertcfg/v32/advertdo4update",

    //11-D 评价标签配置API
    URL_LIST_COMMENTLABELCFGS: BASE_URL + "/syscfg/atdncfg/v30/commentlabelcfg/list",
    URL_SAVE_COMMENTLABELCFG: BASE_URL + "/syscfg/atdncfg/v30/commentlabelcfg",
    URL_UPDATE_COMMENTLABELCFG: BASE_URL + "/syscfg/atdncfg/v30/commentlabelcfg",
    URL_GET_COMMENTLABELCFG: BASE_URL + "/syscfg/atdncfg/v32/commentlabelcfg",
    URL_DELETE_COMMENTLABELCFG: BASE_URL + "/syscfg/atdncfg/v32/commentlabelcfg",

    //11-E 培训证书类型配置API
    URL_LIST_TRAININGCERTCFGS: BASE_URL + "/syscfg/atdncfg/v30/trainingcertcfg/list",
    URL_SAVE_TRAININGCERTCFG: BASE_URL + "/syscfg/atdncfg/v30/trainingcertcfg",
    URL_UPDATE_TRAININGCERTCFG: BASE_URL + "/syscfg/atdncfg/v30/trainingcertcfg",
    URL_GET_TRAININGCERTCFG: BASE_URL + "/syscfg/atdncfg/v32/trainingcertcfg",
    URL_DELETE_TRAININGCERTCFG: BASE_URL + "/syscfg/atdncfg/v32/trainingcertcfg",

    //11-F 系统参数配置API
    URL_GET_SYSTEM_PARAM_DO: BASE_URL + "/syscfg/sysparam/v32/systemparamdo",
    URL_UPDATE_SYSTEM_PARAM: BASE_URL + '/syscfg/sysparam/v33/systemparam',

    //12A-个税列表API
    URL_GET_PAGE_MONTHLY_INCOME_TAXES: BASE_URL + '/finance/indvtax/v33/monthlyincometax/page/filter',
    URL_GET_LIST_TOP_30INSTITUTIONS: BASE_URL + '/finance/indvtax/v33/institution/list/top30/filter',
    URL_GET_EXPORT_MONTHLY_INCOME_TAXES: BASE_URL + '/finance/indvtax/v33/monthlyincometax/list/export/excel',
    URL_GET_LIST_INCOME_TAXI_ITEMS: BASE_URL + '/finance/indvtax/v33/incometaxitem/list',
    URL_GET_LIST_INCOMEI_ITEMS: BASE_URL + '/finance/indvtax/v33/incomeitem/list',

    //12-B 财务对账API
    URL_PAGE_STATEMENTS: BASE_URL + "/finance/actstmt/v21/statement/page/filter",
    URL_GET_STATEMENT_FILTER_DO: BASE_URL + "/finance/actstmt/v21/statementfilterdo",
    URL_GET_STATEMENT_DO4ADD: BASE_URL + "/finance/actstmt/v21/statementdo",
    URL_GET_STATEMENT_DO4UPDATE: BASE_URL + "/finance/actstmt/v32/statementdo",
    URL_SAVE_STATEMENT: BASE_URL + "/finance/actstmt/v21/statement",
    URL_UPDATE_STATEMENT: BASE_URL + "/finance/actstmt/v21/statement",
    URL_DELETE_STATEMENT: BASE_URL + "/finance/actstmt/v32/statement",

    // 12C-分账列表API
    URL_PAGE_REVENUE_SHARINGS: BASE_URL + '/finance/revenuesharing/v32/revenuesharing/page/filter',
    URL_GET_REVENUE_SHARING_FILTER_DO: BASE_URL + '/finance/revenuesharing/v32/revenuesharingfilterdo',
    URL_GET_REVENUE_SHARING_DETAILS: BASE_URL + '/finance/revenuesharing/v32/revenuesharing/details',
    URL_GET_REVENUE_SHARING_DO_4_SHARE: BASE_URL + "/finance/rsharing/v23/revenuesharing/toshare/{id}",
    URL_SAVE_REVENUE_SHARING_LIST: BASE_URL + "/finance/rsharing/v23/revenuesharing/{id}",
    URL_UPDATE_REVENUE_SHARING_ITEM: BASE_URL + '/finance/revenuesharing/v32/revenuesharingitem/{id}',
    URL_APPLY_REVENUE_SHARING: BASE_URL + '/finance/revenuesharing/v32/revenuesharing/apply',


    // 12D-结算账户API
    URL_GET_SETTLEMENT_ACCT_FILTER_DO: BASE_URL + '/finance/settlementacct/v32/settlementaccountfilterdo',
    URL_GET_SETTLEMENT_ACCT_DO: BASE_URL + '/finance/settlementacct/v32/settlementaccountdo',
    URL_GET_SHARING_INCOME_DO: BASE_URL + '/finance/settlementacct/v32/sharingincomedo',
    URL_SAVE_WITH_DRAW: BASE_URL + '/finance/settlementacct/v32/withdraw',

    //20-A 证书数据API
    URL_GET_NEWEST_HEALTH_CERT: BASE_URL + "/external/certdata/v30/certificate/health?idno={attendantIdNo}",

    //20-B 评价数据API
    URL_LIST_NEWEST_COMMENTS: BASE_URL + "/external/cmtdata/v30/comment/list",
};

export default Constant;


// WEBPACK FOOTER //
// ./src/global/Constant.js